import { render } from "./TodoListCard.vue?vue&type=template&id=0179c2be"
import script from "./TodoListCard.vue?vue&type=script&lang=js"
export * from "./TodoListCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/leandro/trabalho-timo/kuhlenbier-web-frontend-partner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__